import type { AccordionPassThrough } from 'primeng/accordion';

/**
 * Pass-through for the root p-accordion component
 */
export const AccordionMonoPT: AccordionPassThrough = {
    root: {
        style: {
            '--p-accordion-panel-border-color': 'var(--p-content-border-color)',
            '--p-accordion-panel-border-width': '0 0 1px 0',
            '--p-accordion-header-color': 'var(--p-text-muted-color)',
            '--p-accordion-header-hover-color': 'var(--p-text-color)',
            '--p-accordion-header-active-color': 'var(--p-text-color)',
            '--p-accordion-header-active-hover-color': 'var(--p-text-color)',
            '--p-accordion-header-background': 'var(--p-content-background)',
            '--p-accordion-header-hover-background': 'var(--p-content-background)',
            '--p-accordion-header-active-background': 'var(--p-content-background)',
            '--p-accordion-header-active-hover-background': 'var(--p-content-background)',
            '--p-accordion-header-toggle-icon-color': 'var(--p-text-muted-color)',
            '--p-accordion-header-toggle-icon-hover-color': 'var(--p-text-color)',
            '--p-accordion-header-toggle-icon-active-color': 'var(--p-text-color)',
            '--p-accordion-header-toggle-icon-active-hover-color': 'var(--p-text-color)',
            '--p-accordion-content-padding': '0 1rem 1rem',
        } as Record<string, string>,
    },
};
